/*
 * *****************************************************************************
 *  Copyright (C)  Motorola Solutions, INC.
 *  All Rights Reserved.
 *  Motorola Solutions Confidential Restricted.
 * *****************************************************************************
 */

import { MessageType } from 'CalltakingCoreApi';

export interface TranslationLanguage {
    languageCode: string;
    name: string;
}

export interface TranslationParticipant {
    type: 'CALLER' | 'CALL_TAKER' | 'SYSTEM';
    callingPartyNumber?: string;
    userName?: string;
    userId?: string;
}

export interface TranslationMessage {
    messageId: string;
    text: string;
}

export interface TranslationResult {
    applied: boolean;
    translatedText: string | null;
    sourceLanguage: string | null;
    targetLanguage: string | null;
}

export interface TranslationCapabilityState {
    enabled: boolean;
    state: 'NOT_STARTED' | 'STARTED' | 'ENDED';
    baseLanguage: string | null;
    targetLanguage: string | null;
}

export interface LanguageChangeMessage {
    id: string;
    timestamp: Date;
    text: string;
}

export enum DisplayMessages {
    ALL = 'ALL',
    BASE_ONLY = 'BASE_ONLY',
    FOREIGN_ONLY = 'FOREIGN_ONLY'
}

export enum TranslationIndicator {
    SHOW_ALL = 'SHOW_ALL',
    HIDE = 'HIDE'
}

export interface TranslationSettings {
    displayMessages: DisplayMessages;
    translationIndicator: TranslationIndicator;
}

export interface MessageErrorParams {
    messageType: MessageType;
    message: string;
    callId: string;
    clusterName: string;
    predefined: boolean;
    language: string;
    userName?: string;
    sourceText?: string;
    sourceLanguage?: string;
    targetText?: string;
    targetLanguage?: string;
    messageLanguage?: string;
}
